export const readContainer = (container = null, component = null) => {
    if(!container){
        container = document.querySelector('.editor-workplace');
    }

    let sections = container.querySelectorAll('.editor-section');
    let result = {};
    let i = 0;
    //console.log(component)
    result = jsonForAllSections(container);
    // if(!component){
    //     result = jsonForAllSections(container);
    // } else {
    //     result = jsonForSection(container, component);
    // }
    return result;
}

/*
* creating json for one section
* @param container - container for searching sections
* @param component - component for searching section
* @return json object
 */
function jsonForSection(container, component) {
    // console.log('jsonForSection')
    // console.log(component)
    // console.log(container)
    let section = container.querySelector('#' + component);
    let result = {};
    result[section.getAttribute('id')] = {
        '@section': section.dataset.section,
        '@order': section.dataset.order,
        '@class': [...section.classList].map((item) => { return item }).join(' '),
        '@style': section.getAttribute('style'),
        '@layout': section.dataset.layout,
        'content': jsonCreate(section),
    };
    return result;
}

/*
* creating json for all sections
* @param container - container for searching sections
* @return json object
* */
function jsonForAllSections(container) {
    //console.log('jsonForAllSections')
    let sections = container.querySelectorAll('.editor-section');
    let result = {};
    let i = 0;
    for(let item of sections){
        i++;
        result[item.getAttribute('id')] = {
            '@section': item.dataset.section,
            '@order': i,
            '@class': [...item.classList].map((item) => { return item }).join(' '),
            '@style': item.getAttribute('style'),
            '@layout': item.dataset.layout,
            'content': jsonCreate(item),
        };
    }

    return result;
}

function jsonCreate(item) {
    //console.log(item)
    let res = {};
    let container = item.querySelector('.editor-section_container');
    switch (item.dataset.section){
        case 'flashcardSection':
            res.flashcards = saveFlashcard(container);
            break;
        case 'gallerySection':
            res.gallery = saveGallery(container);
            break;
        case 'timelineSection':
            res.timeline = saveTimeline(container);
            break;
        case 'matchingSection':
            res.question = item.querySelector('.matching-activity-question span').innerText;
            res.list = saveMatching(container);
            break;
        case 'choiceSection':
            res.question = item.querySelector('.multiple-choice-activity-question span').innerText;
            res.list = saveChoice(container);
            break;
        case 'headingSection':
            res.text = item.querySelector('.fr-element p') ? item.querySelector('.fr-element p').innerHTML : '';
            break;
        case 'tableSection':
            if(item.querySelector('.fr-element')){
                res.text = clearImageURLHtmlString(item.querySelector('.fr-element').innerHTML);
            }
            break;
        case 'paragraphSection':
            res.text = item.querySelector('.fr-element').innerHTML;
            break;
        case 'twoColumnsSection':
            res.text = item.querySelector('.fr-editor-container').innerHTML;
            break;
        case 'listSection':
            res.list = saveList(container);
            break;
        case 'labeledImageSection':
            res = createLabeledImageJSON(item);
            break;
        case 'sortingActivitySection':
            res.list = saveSortingActivity(item);
            break;
        case 'accordionSection':
            res.tabs = saveAccordion(item);
            break;
        case 'tabsSection':
            res.tabs = saveTabs(item);
            break;
        case 'imageTextSection':
            res.image_url = clearImageURL(item.querySelector('.image-container_figure img').getAttribute('src'));
            res.image_caption = item.querySelector('.image-container_figure .image-container_caption').innerText;
            res.image_alt = item.querySelector('.image-container_figure img').getAttribute('alt');
            res.image_width = item.querySelector('.container-width').getAttribute('data-image-width');
            res.asset_id = item.querySelector('.container-width img').dataset.assetId;
            res.text = item.querySelector('.text-box .fr-element').innerHTML;
            break;
        case 'imageSection':
            res.image_url = clearImageURL(item.querySelector('.image-container_figure img').getAttribute('src'));
            res.image_caption = item.querySelector('.image-container_figure .image-container_caption').innerText;
            res.image_alt = item.querySelector('.image-container_figure img').getAttribute('alt');
            res.asset_id = item.querySelector('.image-container_figure img').dataset.assetId;
            break;
        case 'statementSection':
            res.text = item.querySelector('.fr-element').innerHTML;
            break;
        case 'videoSection':
            const vc = item.querySelector('.video-container');
            const vType = vc ? vc.dataset.videoType : '';
            const vUrl = vc ? vc.dataset.videoUrl : '';
            const vThumb = vc ? vc.dataset.videoThumbnail : '';
            // For uploaded videos, strip signed CloudFront URL to relative S3 path (same as images)
            res.video_url = (vType === 'upload') ? clearImageURL(vUrl) : vUrl;
            res.video_type = vType;
            res.video_caption = item.querySelector('.video-container_caption') ? item.querySelector('.video-container_caption').innerText : '';
            res.video_thumbnail = vThumb ? clearImageURL(vThumb) : '';
            break;
        default:
            break;
    }
    return res;
}

/*
* function for clearing string like this from query params and domain name
* */


function clearImageURL(url) {
    // if url has query params - remove it
    if(url.indexOf('?') !== -1){
        url = url.substr(0, url.indexOf('?'));
    }
    // if url has domain name - remove it
    if(url.indexOf('https://devcustomcontent.customguide.com') !== -1){
        url = url.substr(url.indexOf('https://devcustomcontent.customguide.com/') + 'https://devcustomcontent.customguide.com/'.length);
    }
    // if url has domain name - remove it
    if(url.indexOf('https://customcontent.customguide.com') !== -1){
        url = url.substr(url.indexOf('https://customcontent.customguide.com/') + 'https://customcontent.customguide.com/'.length);
    }
    //console.log('new url', url)
    return url;
}

function clearImageURLHtmlString(html) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(html, 'text/html');
    let images = doc.querySelectorAll('img');
    for(let image of images){
        image.src = clearImageURL(image.src);
    }
    return doc.body.innerHTML;
}

function saveFlashcard(container) {
    let result = {};
    if(container.querySelector('.flashcard-item')){
        let listItems = container.querySelectorAll('.flashcard-item');
        let idx = 0;
        for(let listItem of listItems){
            let front = listItem.querySelector('.flashcard-item_front');
            let back = listItem.querySelector('.flashcard-item_back');
            let frontType = front.classList.contains('__image') ? 'image' : 'text';
            let backType = back.classList.contains('__image') ? 'image' : 'text';
            result[idx] = {
                id: listItem.id,
                front: {
                    type: frontType,
                    content: frontType === 'text' ? front.querySelector('.flashcard-card-inner').innerText : '',
                    image: frontType === 'image' ? clearImageURL(front.querySelector('.flashcard-card-inner img').getAttribute('src')) : '',
                    asset_id: frontType === 'image' ? front.querySelector('.flashcard-card-inner img').getAttribute('data-asset-id') : '',
                },
                back: {
                    type: backType,
                    content: backType === 'text' ? back.querySelector('.flashcard-card-inner').innerText : '',
                    image: backType === 'image' ? clearImageURL(back.querySelector('.flashcard-card-inner img').getAttribute('src')) : '',
                    asset_id: backType === 'image' ? back.querySelector('.flashcard-card-inner img').getAttribute('data-asset-id') : '',
                }
            }
            idx++;
        }
    }
    return result;
}

function saveGallery(container) {
    let result = {};
    if(container.querySelector('.gallery-item')){
        let listItems = container.querySelectorAll('.gallery-item');
        let idx = 0;
        for(let listItem of listItems){
            result[idx] = {
                'id': idx,
                'asset_id': listItem.querySelector('img').getAttribute('data-asset-id'), // componentsHelper.setAssetUniqueID(null, idx, param.id, 'image'),
                'src': clearImageURL(listItem.querySelector('img').getAttribute('src')),
                'caption': listItem.querySelector('figcaption').innerText,
                'alt': listItem.querySelector('img').getAttribute('alt'),
            }
            idx++;
        }
    }
    return result;
}

function saveMatching(container) {
    let result = {};
    if(container.querySelector('.matching-activity')){
        let listQuestions = container.querySelectorAll('.matching-questions_item');
        let idx = 0;
        for(let listItem of listQuestions){
            result[idx] = {
                'id': idx,
                'question': listItem.querySelector('span').innerText,
            }
            idx++;
        }
        let listAnswers = container.querySelectorAll('.matching-answers_item');
        let idxx = 0;
        for(let listAnswerItem of listAnswers){
            result[idxx].matching = listAnswerItem.querySelector('span').innerText;
            idxx++;
        }
    }
    return result;
}

function saveChoice(container) {
    let result = {};
    if(container.querySelector('.multiple-choice-item')){
        let listItems = container.querySelectorAll('.multiple-choice-item');
        let idx = 0;
        for(let listItem of listItems){
            result[idx] = {
                'id': idx,
                'option': listItem.querySelector('.multiple-choice-item_content span').innerText,
                'correct': listItem.querySelector('.multiple-choice-item_correct input').checked,
            }
            idx++;
        }
    }
    return result;
}

function saveList(container) {
    let result = {};
    if(container.querySelector('li')){
        let listItems = container.querySelectorAll('li');
        let idx = 0;
        for(let listItem of listItems){
            result[idx] = clearImageURLHtmlString(listItem.innerHTML),
            idx++;
        }
    }
    return result;
}

function saveTimeline(item) {
    let result = {};
    const timelines = item.querySelectorAll('.timeline-item');
    let idx = 0;
    for (let timeline of timelines) {
        result[idx] = {
            'date': timeline.querySelector('.subheading').innerText,
            'title': timeline.querySelector('.heading').innerText,
            'text': timeline.querySelector('.fr-element').innerHTML,
        }
        idx++;
    }
    return result;
}

function saveAccordion(item) {
    let result = {};
    let list = item.querySelector('.accordion-section-list');
    let tabs = list.querySelectorAll('.accordion-section-item');
    let idx = 0;
    for(let tab of tabs){
        result[idx] = {
            'id': tab.dataset.id ? tab.dataset.id : '',
            'title': tab.querySelector('.accordion-section-item__header h3').innerText,
            'content': tab.querySelector('.fr-element.fr-view').innerHTML,
            'asset_id': tab.querySelector('.img-content') ? tab.querySelector('.img-content img').getAttribute('data-asset-id') : '',
            'image_url': tab.querySelector('.img-content') ? clearImageURL(tab.querySelector('.img-content img').getAttribute('src')) : '',
            'order': tab.dataset.order,
        }
        idx++;
    }
    return result;
}
function saveTabs(item) {
    let result = {};
    let list = item.querySelector('.tabs-box');
    let tabsHead = list.querySelectorAll('.tab-header');
    let tabsContent = list.querySelectorAll('.tab-item');
    let idx = 0;
    for(let tab of tabsHead){
        result[idx] = {
            'id': tab.dataset.tab ? tab.dataset.tab : '',
            'title': tab.querySelector('span.editable-text').innerText,
            'text': clearImageURLHtmlString(tabsContent[idx].querySelector('.fr-element').innerHTML),
            'order': tab.dataset.tab,
        }
        idx++;
    }
    return result;
}

function createLabeledImageJSON(item) {
    let result = {
        'labels':{},
        'image_url': clearImageURL(item.querySelector('.image-container_figure img').getAttribute('src')),
        'image_caption': item.querySelector('.image-container_figure .image-container_caption').innerText,
        'image_alt': item.querySelector('.image-container_figure img').getAttribute('alt'),
        'asset_id': item.querySelector('.image-container_figure img').getAttribute('data-asset-id'),
    };
    let labels = item.getElementsByClassName('li-label-item');
    let labels_json = {};
    let idx = 0;
    for(let label of labels){
        labels_json[idx] = {
            'id': label.id,
            'order': label.dataset.label,
            'style': label.getAttribute('style'),
            'image_url': label.querySelector('img') ? clearImageURL(label.querySelector('img').getAttribute('src')) : '',
            'image_alt': label.querySelector('img') ? label.querySelector('img').getAttribute('alt') : '',
            'asset_id': label.querySelector('img') ? label.querySelector('img').getAttribute('data-asset-id') : '',
            'heading': label.querySelector('h4') ? label.querySelector('h4').innerHTML : '',
            'text': label.querySelector('p') ? label.querySelector('p').innerHTML : ''
        };
        idx++;
    }
    result.labels = labels_json;
    return result;
}

function saveSortingActivity(component) {
    let cards = component.querySelectorAll('.sorting-activity-item');
    let sections = component.querySelectorAll('.sorting-activity-area');
    let result_cards = {};
    let result_sections = {};
    for(let card of cards){
        result_cards[card.dataset.id] = {
            'id': card.dataset.id,
            'title': card.querySelector('span').innerHTML,
            'section_id': card.dataset.category,
        }
    }
    for(let section of sections){
        result_sections[section.dataset.id] = {
            'id': section.dataset.id,
            'title': section.querySelector('span').innerHTML,
        }
    }
    return {
        'cards': result_cards,
        'sections': result_sections
    }
}
